import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


//constants
import { Constants }         from '../../constants/Constants';


@Component({
  selector: 'my-requestvalidationmessages',
  templateUrl: './RequestValidationMessages.component.html'
})
export class RequestValidationMessagesComponent implements OnInit {

    
    public messages: ent.ValidationMessage[]= [];
    public displayDialog: boolean;
    public showIconColumn: boolean;
    public showCategoryColumn: boolean = true;
    public isModal: boolean = false;

    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService) 
    {

    }

    ngOnInit(): void {
    }

    onHide(){
        this.displayDialog = false;
    }

    showError(msg: ent.ValidationMessage) : boolean {
      return msg.Category==Constants._SEVERITY_ERROR;
    }

    showWarning(msg: ent.ValidationMessage) : boolean {
      return msg.Category==Constants._SEVERITY_WARNING;
    }

    showInfo(msg: ent.ValidationMessage) : boolean {
      return msg.Category==Constants._SEVERITY_INFO;
    }

}